module.exports = "<div class=\"embed-responsive-item video-html\">\n  <div id=\"<%= playerId %>\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/cigna-frontend/js/views/limelight-html5.tpl.html
// module id = 3tax
// module chunks = 4